module.exports = __webpack_public_path__ + "images/living-kitchen-c208ae936e996f93ee4ed015c9273f60.jpg";